import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Home, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("documenti@investart.it");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-secondary">
        <img
          src="https://images.unsplash.com/photo-1507110230240-6e2d230fd528?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Reggio Emilia"
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary via-secondary/70 to-secondary/30" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-primary grid place-items-center">
              <Home className="h-5 w-5" />
            </div>
            <span className="font-display text-2xl font-bold">InvestArt</span>
          </div>
          <div>
            <h2 className="font-display text-4xl font-bold leading-tight">CRM Operativo Immobiliare</h2>
            <p className="mt-3 text-white/70 max-w-md">
              Gestione contatti, immobili, valutazioni di acquisizione, preventivi e follow-up per il team di Reggio Emilia.
            </p>
          </div>
          <div className="text-xs text-white/50">Dati dimostrativi · Nessun dato reale di clienti</div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 bg-background">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-9 w-9 rounded-lg bg-primary text-white grid place-items-center">
              <Home className="h-5 w-5" />
            </div>
            <span className="font-display text-xl font-bold">InvestArt</span>
          </div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Accedi al gestionale</h1>
          <p className="text-sm text-muted-foreground mt-1 mb-6">Inserisci le tue credenziali aziendali.</p>

          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-slate-700">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                placeholder="nome@investart.it"
                required
              />
            </div>
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-slate-700">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                placeholder="••••••••"
                required
              />
            </div>
            {error && (
              <div className="rounded-lg bg-rose-50 border border-rose-200 px-3 py-2 text-sm text-rose-700" data-testid="login-error">
                {error}
              </div>
            )}
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
